import { useDispatch, useSelector } from 'react-redux';
import { useLazyQuery } from '@apollo/client';
import { FIND_CART_BY_CLIENT_ID } from '../../../apollo';
import { cartSlice, CartState, StoreState } from '../../../redux';
import { Cart } from '@hiwaldo/sdk/interfaces';

type FindCartByClientIdEffectReturn = {
  findCartByClientId: (clientId: string, fetched?: boolean) => void;
  cart: Cart | null;
  loading: boolean;
  error: string | undefined;
};

export const useFindCartByClientIdEffect = (
  callback?: () => void
): FindCartByClientIdEffectReturn => {
  const dispatch = useDispatch();

  const { cart } = useSelector(
    (state: StoreState) => state.orders.cart
  ) as CartState;

  const onCompleted = (data: any) => {
    dispatch(cartSlice.actions.updateCart(data.findCartByClientId));
    if (callback) {
      callback();
    }
  };

  const onError = (error: any) => {
    console.error(error);
  };

  const [doFindCartByClientId, findCartByClientIdState] = useLazyQuery(
    FIND_CART_BY_CLIENT_ID,
    { onCompleted, onError, fetchPolicy: 'no-cache' }
  );

  const loading = findCartByClientIdState.loading;
  const error = findCartByClientIdState.error;

  const findCartByClientId = (clientId: string, withTax = false): void => {
    const variables = withTax
      ? { clientId, option: { fetchTax: true } }
      : { clientId };

    doFindCartByClientId({ variables });
  };

  return { findCartByClientId, cart, loading, error: error?.message };
};
